import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { environment } from 'src/environments/environment';
import { MyserviceService } from '../myservice.service';
@Component({
  selector: 'app-sfg-partners',
  templateUrl: './sfg-partners.component.html',
  styleUrls: ['./sfg-partners.component.css'],
  providers: [MessageService,ConfirmationService],
})
export class SfgPartnersComponent implements OnInit {
  rowsNo = 0;
  offset:number = 0;
  pageSize:number = 10;
  noOfRecords: number=0;
  hasSearched=false;
  sortField: String="createdDate";
  sortOrder: number = -1;
  addPartnerForm: any;
  statusArray: any = [{ label: "Select", value: "-1" }, { label: "ACTIVE", value: "ACTIVE" }, { label: "INACTIVE", value: "INACTIVE" }]
  detailInfoPartnerForm: any;
  loader: boolean;
  partnerData: any = [];
  headers: any;
  document: { sfgPartnerName: any; status: any; sfgCountryCode: any; };
  resultMessage: string;
  responseViewTime: boolean;
  display: boolean;
  updateResponse: string;
  responseMsg: boolean;
  roleId: any;
  addPartnerAccess: boolean=false;
  isProd:boolean=environment.prod;
  constructor(private fb: FormBuilder, public localstorage: LocalStorageService, private http: HttpClient,private messageService: MessageService,public session: SessionStorageService,
  public datepipe: DatePipe, private service: MyserviceService,private confirmationService: ConfirmationService) { }
  tableHeaders = [
    { field: "sfgPartnerName", header: "Name", width: "10%" },
    { field: "sfgCountryCode", header: "Country", width: "7%" },
    { field: "status", header: "Status", width: "6%" },
    { field: "createdDate", header: "Created on", width: "10%" },
  ];
  ngOnInit() {
    this.roleId=this.session.retrieve("UserDetails").roleId;
    if (this.roleId==1) {
      this.tableHeaders.push( { field: "", header: "Delete Account", width: "5%" })
    }
    this.addPartnerAccess=this.session.retrieve("UserDetails").addPartnersAccess;
    this.headers = new HttpHeaders();
    this.headers = this.headers.append(
      "authorization",
      this.localstorage.retrieve("token")
    );
    
    this.addPartnerForm = this.fb.group({
      partnerName: new FormControl("", Validators.required),
      status: new FormControl("", Validators.required),
      countryCode: new FormControl("", Validators.required),
    });
    this.detailInfoPartnerForm = this.fb.group({
      partnerName: new FormControl("", Validators.required),
      status: new FormControl("", Validators.required),
      countryCode: new FormControl("", Validators.required),
    });
  }
 //For server side pagination and sorting
 onPagination(data) {
  this.rowsNo = data.first + data.rows >= this.noOfRecords ? this.noOfRecords : data.first + data.rows;
  //Checking if the previous pagination and sorting fields are different with latest fields or not to reduce the API hits
  if (data.first != this.offset || data.rows != this.pageSize || data.sortField != this.sortField || data.sortOrder != this.sortOrder) {
      this.offset = data.first;
      this.pageSize = data.rows;
      this.sortField = data.sortField;
      this.sortOrder = data.sortOrder;
      this.search();
  }
}
  add() {
    this.document = {
      sfgPartnerName: this.addPartnerForm.value.partnerName,
      status: this.addPartnerForm.value.status,
      sfgCountryCode:this.addPartnerForm.value.countryCode
    }
    this.http
        .post(environment.apiUrl + "/sfg/addSfgPartner", this.document, {
            headers: this.headers,
            responseType: "text",
        })
        .subscribe((data) => {
            this.resultMessage = data;
            if (this.resultMessage == "SFG partner Id already existed!" || this.resultMessage =="") {
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: this.resultMessage,
                });
            } else {
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: this.resultMessage,
                });
              this.addPartnerForm.reset();
              this.setDefaultPagination();
              this.search(true);
            }          
        });
}
  search(countFlag = false) {
    this.document = {
      sfgPartnerName: this.addPartnerForm.value.partnerName,
      status: this.addPartnerForm.value.status,
      sfgCountryCode:this.addPartnerForm.value.countryCode
    }
    let reqPayload:any={...this.document}
    reqPayload.limit = this.pageSize;
    reqPayload.offSet = this.offset;
    reqPayload.sortField = this.sortField;
    reqPayload.sortOrder = this.sortOrder == 1 ? "ASC" : "DESC";
    reqPayload.countFlag = countFlag;
    this.loader = true;
    this.partnerData = [];
    this.http
      .post(environment.apiUrl + "/sfg/partnerSearch", reqPayload, {
        headers: this.headers,
      })
      .subscribe((res:any) => {
        this.partnerData = res.data;
        if (countFlag) {
          this.noOfRecords = res.totalRecordsCount;
        }
        this.loader = false;
      });
  }
  setDefaultPagination(){
    this.hasSearched = false;
    this.offset = 0;
    this.pageSize = 10;
    this.noOfRecords = 0;
    this.sortField = "createdDate";
    this.sortOrder = -1;
  }
  reset() {
    this.setDefaultPagination();
    this.addPartnerForm.reset()
    this.partnerData = [];
  }
  details(data){
    this.display = true;
    this.detailInfoPartnerForm.patchValue({
      partnerName:data.sfgPartnerName,
      status:data.status,
      countryCode:data.sfgCountryCode
    })
  }
  update(){
    this.updateResponse = "";
    this.document = {
      sfgPartnerName: this.detailInfoPartnerForm.value.partnerName,
      status: this.detailInfoPartnerForm.value.status,
      sfgCountryCode:this.detailInfoPartnerForm.value.countryCode
    }
    //this.updateInfo = partnerInfo;
    this.http
        .post(environment.apiUrl + "/sfg/update", this.document, {
            headers: this.headers,
            responseType: "text",
        })
        .subscribe((data) => {
            this.updateResponse = data;
            this.addPartnerForm.reset();
            this.setDefaultPagination();
            this.search(true);
            this.responseMsg = true;
            setTimeout(
                function () {
                    this.responseMsg = false;
                }.bind(this),
                2000
            );
        });
  }
  deleteAccount(name:any) {
    this.confirmationService.confirm({
        message: `Are you sure that you want to delete?`,
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        key: "positionDialog",
        accept: () => {
            this.loader = true;
            let headers = new HttpHeaders();
            headers = headers.append(
                "authorization",
                this.localstorage.retrieve("token")
            );
            this.http.delete(environment.apiUrl + "/sfg/partnerDelete", { headers: headers, params: { partnerName: name },responseType:"text" })
                .subscribe((data: any) => {
                    this.loader = false;
                    if (data == "Partner deleted seccessfully") {
                        this.setDefaultPagination();
                        this.search(true);
                        this.messageService.add({
                            severity: "success",
                            detail: "Partner deleted seccessfully",
                        });
                    } else {
                        this.messageService.add({
                            severity: "error",
                            detail: data,
                        });
                    }
                });
        },
        reject: () => {
        }
    });
}

  //to generate the excel report
    generateExcel(){
      let document={...this.addPartnerForm.value};
        document.sortField=this.sortField;
        document.sortOrder= this.sortOrder == 1 ? "ASC" : "DESC";
        document.countFlag=false;
      let fileName = "SfgPartnersReport_" + this.datepipe.transform(this.service.getDateByTZ(), "ddMMyyyy_HHmm", "+0000") + ".xlsx"
      this.service.downloadPartnerReport(
        "/sfg/sfgPartnersExcelDownload",
        document,
        fileName,
        this.headers
      );
    }
}
